<template>
    <div class="main">
        <div class="maincon">
            <div class="bread">首页 > 我的玫德 > {{ breadTitle }}</div>
            <div class="flexbox content">
                <!-- <div class="leftpart">
                    <div class="item" v-for="(item, index) in minelist" :key="index">
                        <h2>{{ item.h }}</h2>
                        <ul>
                            <li v-for="(it, idx) in item.list" :key="index" @click="routerCh(it.title)"><router-link :to="{name: it.name}">{{ it.title }}</router-link></li>
                        </ul>
                    </div>
                </div> -->
                <div class="rightpart">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, map, onUpdated } from 'vue'
    import { getUrlRelativePath } from'@/util/util.js'

    export default {
        name: 'Mine',
        components: {
            
        },
        setup() {
            let minelist = ref([
                {h: '我的账户', list: [
                    {title: '个人中心', name: 'PersonalCenter', url: 'personalcenter'},
                    {title: '消息通知', name: 'Notification', url: 'notification'},
                    {title: '安全设置', name: '', url: ''},
                ]},
                {h: '订单管理', list: [
                    {title: '我的订单', name: 'MyOrder', url: 'myorder'},
                    {title: '退货订单', name: '', url: ''},
                    {title: '样品申请', name: '', url: ''},
                    {title: '我的收藏', name: 'MyCollection', url: 'mycollection'},
                    {title: '我的业务', name: 'Profile', url: 'profile'},
                    {title: '知识库', name: 'Zhishiku', url: 'zhishiku'},
                    {title: '历史订单', name: 'OrderPath', url: 'orderPath'},
                    {title: '修改密码', name: 'ChangePwd', url: 'changePwd'},
                    {title: '我的优惠券', name: '', url: ''},
                    {title: '售后服务', name: '', url: ''},
                    {title: '财务查询', name: 'FinancialInquiry', url: 'financialinquiry'},
                    {title: '财务概览', name: 'FinancialOverview', url: 'financialoverview'},
                    {title: '业绩查询', name: 'PerformanceInquiry', url: 'performanceinquiry'},
                ]},
                {h: '客户服务', list: [
                    {title: '我要咨询', name: '', url: ''},
                    {title: '我要投诉', name: '', url: ''},
                    {title: '我的问题', name: 'MyQuestion', url: 'myquestion'},
                    {title: '知识库', name: 'KnowledgeBase', url: 'knowledgebase'},
                    {title: '帮助中心', name: '', url: ''},
                    {title: '在线客服', name: '', url: ''},
                ]},
            ])
            let breadTitle = ref('个人中心')
            let routerCh = (title) => {
                breadTitle.value = title
            }
            onMounted(() => {
                let arrurl = getUrlRelativePath().split('/')
                let urlname = arrurl[arrurl.length-1]
                for(let a = 0; a < minelist.value.length; a ++) {
                    let list = minelist.value[a].list
                    for(let b = 0; b < list.length; b ++) {
                        if(list[b].url == urlname) {
                            breadTitle.value = list[b].title
                        }
                    }
                }
                if(urlname == 'orderdetail') {
                    breadTitle.value = '订单详情'
                }else if (urlname == 'problemhandling') {
                    breadTitle.value = '我的问题'
                }
            })
            onUpdated(() => {
                let arrurl = getUrlRelativePath().split('/')
                let urlname = arrurl[arrurl.length-1]
                for(let a = 0; a < minelist.value.length; a ++) {
                    let list = minelist.value[a].list
                    for(let b = 0; b < list.length; b ++) {
                        if(list[b].url == urlname) {
                            breadTitle.value = list[b].title
                        }
                    }
                }
                if(urlname == 'orderdetail') {
                    breadTitle.value = '订单详情'
                }
            })
            return {
                minelist,
                breadTitle,
                routerCh
            }
        }
    }
</script>

<style scoped lang="scss">
    .main {
        background: #fafafa;
        padding-bottom: 50px;
    }
    .maincon {
        width: 1200px;
        margin: auto;
        padding-top: 20px;
        .bread {
            margin-bottom: 15px;
            font-size: 12px;
        }
        .content {
            justify-content: space-between;
            align-items: flex-start;
            .leftpart {
                background: #fff;
                border: 1px solid rgba(228, 228, 228, 1);
                padding: 5px 45px 20px 45px;
                .item {
                    text-align: center;
                    margin-top: 15px;
                    h2 {
                        font-size: 16px;
                    }
                    ul {
                        li {
                            margin-top: 15px;
                            a {
                                font-size: 12px;
                                color: #666;
                                &:hover {
                                    color: rgb(244 ,36, 52);
                                }
                            }
                        }
                    }
                }
            }
            .rightpart {
                /* width: 1020px; */
                width: 100%;
            }
        }
    }
</style>